import * as _ from 'lodash';

export interface Template {
  templateId: number;
  templateName: string;
  templateDescription: string;
  aspectRatioId: number;
  state: string;        // enum (DRAFT, SUBMITTED)
  isBackgroundImagePresent: boolean;
  backgroundColor: string;    // HEX color code. eg #888888
  regions: Array<Region>;
  layoutTags: Array<LayoutTag>;
  aspectRatio: AspectRatio;
  transparencyInPercentage: string;

}

export interface Region {
  templateRegionId: string;
  templateRegionName: string;
  widthInPixel: number;
  heightInPixel: number;
  topLeftCoordinateXInPixel: number;
  topLeftCoordinateYInPixel: number;
  zIndex: number;
  draggable: boolean;
  resizable: boolean;
}

export interface CustomRegion {
  templateRegionId: string;
  templateRegionName: string;
  widthInPixel: number;
  heightInPixel: number;
  topLeftCoordinateXInPixel: number;
  topLeftCoordinateYInPixel: number;
  zIndex: number;
  draggable: boolean;
  resizable: boolean;
  customAspectRatioActualWidth:number;
  customAspectRatioActualHeight:number;
}

export interface ActualRegion {
  actheightInPixel: number;
  actwidthInPixel: number;
  acttopLeftCoordinateXInPixel: number;
  acttopLeftCoordinateYInPixel: number;
}

export const containerConfig = {
  'margins': [0, 0, 0, 0],
  'draggable': false,
  'resizable': false,
  'max_cols': 0,
  'max_rows': 0,
  'visible_cols': 0,
  'visible_rows': 0,
  'min_cols': 0,
  'min_rows': 0,
  'col_width': 1,
  'row_height': 1,
  'cascade': '',
  'min_width': 50,
  'min_height': 50,
  'fix_to_grid': true,
  'auto_style': true,
  'auto_resize': false,
  'maintain_ratio': false,
  'prefer_new': false,
  'zoom_on_drag': false,
  'limit_to_screen': true,
  'allow_overlap': true,
  // 'widget_width_factor': 1,
  // 'widget_height_factor': 1
};

export const CONST_DEFAULT_CONFIG = {
  col: 50,
  row: 50,
  sizex: 100,    // width
  sizey: 70,     // height
  // dragHandle: null,
  // resizeHandle: null,
  // fixed: false,
  draggable: false,
  resizable: false,
  borderSize: 10,
  // unitx: 0,
  // unity: 0
};
export interface LayoutTag {
  layoutTag: string;
}

export interface AspectRatio {
  aspectRatioId: number,
  aspectRatio: string,
  status: number;
  defaultWidthInPixel: number;
  defaultHeightInPixel: number;
  actualHeightInPixel:number;
  actualWidthInPixel: number;
}
export class Container {
  static MAX_WINDOW_WIDTH: number = 855;//960; //px
  static readonly MAX_WINDOW_HEIGHT: number = 486;//540; //px
  width: number;
  height: number;
  scaleNum: number = 1;
  actualWidth: number;
  actualHeight: number;
  calculateScaleNum = () => {
    if (this.actualWidth >= this.actualHeight) {
      this.scaleNum = _.floor(Container.MAX_WINDOW_WIDTH / this.actualWidth, 2);
    }
    else {
      this.scaleNum = _.floor(Container.MAX_WINDOW_HEIGHT / this.actualHeight, 2);
    }
  }
  setActualHightAndWidth = (_width, _height) => {
    if (!/^[0-9]+$/.test(_width) || !/^[0-9]+$/.test(_height))
      return;
    this.actualWidth = _.toNumber(_width);
    this.actualHeight = _.toNumber(_height);
    this.calculateScaleNum();
    this.width = this.scaleNum * this.actualWidth;
    this.height = this.scaleNum * this.actualHeight;
    // console.log("setActualHightAndWidth() AFTER > ", this);
    //setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 1);
  };
  getRegionValueByWidgetConfig = (_conf, _oldVal: Region) => {
    let _region: Region = _oldVal;
    if (_conf) {
      if (_conf.sizex != null) _region.widthInPixel = _.floor(_conf.sizex / this.scaleNum);
      if (_conf.sizey != null) _region.heightInPixel = _.floor(_conf.sizey / this.scaleNum);
      if (_conf.col != null) _region.topLeftCoordinateXInPixel = Math.max(_.floor(((_conf.col) / this.scaleNum)) - 1, 0);
      if (_conf.row != null) _region.topLeftCoordinateYInPixel = Math.max(_.floor(((_conf.row) / this.scaleNum)) - 1, 0);
      if (_conf.draggable != null) _region.draggable = _conf.draggable;
      if (_conf.resizable != null) _region.resizable = _conf.resizable;
    }
    /*
      col: this._currentPosition.col,
      row: this._currentPosition.row,
      sizex: this._size.x,
      sizey: this._size.y,
      width: this._elemWidth,
      height: this._elemHeight,
      left: this._elemLeft,
      top: this._elemTop*/
    return _region;
  }

  public getRegionActualValueByWidgetConfig(_region, aspectRatio){
    //let _newRegionConfig:Region = _region;
    let _newRegionConfig:CustomRegion = _region;
   // aspWidth  = aspectRatio.aspectRatio.split(':')[0];
    //aspHeight  = aspectRatio.aspectRatio.split(':')[1]
    _newRegionConfig.customAspectRatioActualWidth = aspectRatio.actualWidthInPixel;
    _newRegionConfig.customAspectRatioActualHeight = aspectRatio.actualHeightInPixel;

      if(_region.widthInPixel) _newRegionConfig.widthInPixel = _.floor((_region.widthInPixel * aspectRatio.actualWidthInPixel) / aspectRatio.defaultWidthInPixel);
      if (_region.heightInPixel != null) _newRegionConfig.heightInPixel = _.floor((_region.heightInPixel * aspectRatio.actualHeightInPixel) / aspectRatio.defaultHeightInPixel);
      if (_region.topLeftCoordinateXInPixel != null) _newRegionConfig.topLeftCoordinateXInPixel = Math.max(_.floor((_region.topLeftCoordinateXInPixel * aspectRatio.actualWidthInPixel) / aspectRatio.defaultWidthInPixel), 0);
      if (_region.topLeftCoordinateYInPixel != null) _newRegionConfig.topLeftCoordinateYInPixel = Math.max(_.floor((_region.topLeftCoordinateYInPixel * aspectRatio.actualHeightInPixel) / aspectRatio.defaultHeightInPixel), 0);
      if (_region.draggable != null) _newRegionConfig.draggable = _region.draggable;
      if (_region.resizable != null) _newRegionConfig.resizable = _region.resizable;
      return _newRegionConfig;
  }

  public getContainerActualValueByWidgetConfigWidth(_region, aspectRatio,customWidth:number){
    let _newRegionConfig:CustomRegion = _region,aspWidth,aspHeight;
    if(!customWidth) return;
    aspWidth  = aspectRatio.aspectRatio.split(':')[0];
    aspHeight  = aspectRatio.aspectRatio.split(':')[1]
      if (customWidth) _newRegionConfig.customAspectRatioActualHeight = _.floor((1/(aspWidth/aspHeight)) * customWidth);
      if (customWidth) _newRegionConfig.customAspectRatioActualWidth = customWidth; 
      if (_region.widthInPixel) _newRegionConfig.widthInPixel = _.floor((_region.widthInPixel * customWidth) / aspectRatio.defaultWidthInPixel);
      if (_region.heightInPixel != null) _newRegionConfig.heightInPixel = _.floor((_region.heightInPixel * _newRegionConfig.customAspectRatioActualHeight) / aspectRatio.defaultHeightInPixel);
      if (_region.topLeftCoordinateXInPixel != null) _newRegionConfig.topLeftCoordinateXInPixel = Math.max(_.floor((_region.topLeftCoordinateXInPixel * customWidth) / aspectRatio.defaultWidthInPixel), 0);
      if (_region.topLeftCoordinateYInPixel != null) _newRegionConfig.topLeftCoordinateYInPixel = Math.max(_.floor((_region.topLeftCoordinateYInPixel * _newRegionConfig.customAspectRatioActualHeight) / aspectRatio.defaultHeightInPixel), 0);
      if (_region.draggable != null) _newRegionConfig.draggable = _region.draggable;
      if (_region.resizable != null) _newRegionConfig.resizable = _region.resizable;
      return _newRegionConfig;
  }

  public getContainerActualValueByWidgetConfigHeight(_region, aspectRatio,customHeight:number){
    let _newRegionConfig:CustomRegion = _region,aspWidth,aspHeight;
    if(!customHeight) return;
    aspWidth  = aspectRatio.aspectRatio.split(':')[0];
    aspHeight  = aspectRatio.aspectRatio.split(':')[1]
      if (customHeight) _newRegionConfig.customAspectRatioActualHeight = customHeight;
      if (customHeight) _newRegionConfig.customAspectRatioActualWidth = _.floor((aspWidth/aspHeight) * customHeight); 
      if (_region.widthInPixel) _newRegionConfig.widthInPixel = _.floor((_region.widthInPixel * _newRegionConfig.customAspectRatioActualWidth) / aspectRatio.defaultWidthInPixel);
      if (_region.heightInPixel != null) _newRegionConfig.heightInPixel = _.floor((_region.heightInPixel * customHeight) / aspectRatio.defaultHeightInPixel);
      if (_region.topLeftCoordinateXInPixel != null) _newRegionConfig.topLeftCoordinateXInPixel = Math.max(_.floor((_region.topLeftCoordinateXInPixel * _newRegionConfig.customAspectRatioActualWidth) / aspectRatio.defaultWidthInPixel), 0);
      if (_region.topLeftCoordinateYInPixel != null) _newRegionConfig.topLeftCoordinateYInPixel = Math.max(_.floor((_region.topLeftCoordinateYInPixel * customHeight) / aspectRatio.defaultHeightInPixel), 0);
      if (_region.draggable != null) _newRegionConfig.draggable = _region.draggable;
      if (_region.resizable != null) _newRegionConfig.resizable = _region.resizable;
      return _newRegionConfig;
  }

  public getContainerActualValueByWidgetConfigWidthHeight(_region, aspectRatio,customWidth:number,customHeight:number){
    let _newRegionConfig:CustomRegion = _region,aspWidth,aspHeight;
    if(!customHeight) return;
    aspWidth  = aspectRatio.aspectRatio.split(':')[0];
    aspHeight  = aspectRatio.aspectRatio.split(':')[1]
      if (customWidth) _newRegionConfig.customAspectRatioActualWidth = customWidth; 

      if (customHeight) _newRegionConfig.customAspectRatioActualHeight = customHeight;

      if (_region.widthInPixel) _newRegionConfig.widthInPixel = _.floor((_region.widthInPixel * _newRegionConfig.customAspectRatioActualWidth) / aspectRatio.defaultWidthInPixel);
      if (_region.heightInPixel != null) _newRegionConfig.heightInPixel = _.floor((_region.heightInPixel * customHeight) / aspectRatio.defaultHeightInPixel);
      if (_region.topLeftCoordinateXInPixel != null) _newRegionConfig.topLeftCoordinateXInPixel = Math.max(_.floor((_region.topLeftCoordinateXInPixel * _newRegionConfig.customAspectRatioActualWidth) / aspectRatio.defaultWidthInPixel), 0);
      if (_region.topLeftCoordinateYInPixel != null) _newRegionConfig.topLeftCoordinateYInPixel = Math.max(_.floor((_region.topLeftCoordinateYInPixel * customHeight) / aspectRatio.defaultHeightInPixel), 0);
      if (_region.draggable != null) _newRegionConfig.draggable = _region.draggable;
      if (_region.resizable != null) _newRegionConfig.resizable = _region.resizable;
      return _newRegionConfig;
  }

  public getRegionDefaultValueByWidgetConfig(_region,actheightInPixel,actwidthInPixel, acttopLeftCoordinateXInPixel, acttopLeftCoordinateYInPixel, aspectRatio){
    //let _newRegionConfig:Region = _region;
    //console.log("abhik _region",_region)
    let _newRegionConfig:ActualRegion =_region;

      /*if(actwidthInPixel != 0) _newRegionConfig.actwidthInPixel = _.floor((actwidthInPixel * aspectRatio.defaultWidthInPixel) / aspectRatio.actualWidthInPixel);
      if (actheightInPixel != 0) _newRegionConfig.actheightInPixel = _.floor((actheightInPixel * aspectRatio.defaultHeightInPixel) / aspectRatio.actualHeightInPixel);
      if (acttopLeftCoordinateXInPixel != 0) _newRegionConfig.acttopLeftCoordinateXInPixel = Math.max(_.floor((acttopLeftCoordinateXInPixel * aspectRatio.defaultWidthInPixel) / aspectRatio.actualWidthInPixel), 0);
      if (acttopLeftCoordinateYInPixel != 0) _newRegionConfig.acttopLeftCoordinateYInPixel = Math.max(_.floor((acttopLeftCoordinateYInPixel * aspectRatio.defaultHeightInPixel) / aspectRatio.actualHeightInPixel), 0);
      return _newRegionConfig;*/
      if(actwidthInPixel != 0) _newRegionConfig.actwidthInPixel = _.floor((actwidthInPixel * aspectRatio.defaultWidthInPixel) / _region.customAspectRatioWidth);
      if (actheightInPixel != 0) _newRegionConfig.actheightInPixel = _.floor((actheightInPixel * aspectRatio.defaultHeightInPixel) / _region.customAspectRatioHeight);
      if (acttopLeftCoordinateXInPixel != 0) _newRegionConfig.acttopLeftCoordinateXInPixel = Math.max(_.floor((acttopLeftCoordinateXInPixel * aspectRatio.defaultWidthInPixel) / _region.customAspectRatioWidth), 0);
      if (acttopLeftCoordinateYInPixel != 0) _newRegionConfig.acttopLeftCoordinateYInPixel = Math.max(_.floor((acttopLeftCoordinateYInPixel * aspectRatio.defaultHeightInPixel) / _region.customAspectRatioHeight), 0);
      return _newRegionConfig;
  }

  // getWidgetConfigByRegionValue = (_region: Region, _oldconf) => {
  //   let _conf: any = _oldconf;
  getWidgetConfigByRegionValue = (_region?: Region, _oldconf?) => {
    let _conf: any = _oldconf || _.clone(CONST_DEFAULT_CONFIG);
    if (_region) {
      if (_region.widthInPixel != null) _conf.sizex = (_region.widthInPixel * this.scaleNum);
      if (_region.heightInPixel != null) _conf.sizey = (_region.heightInPixel * this.scaleNum);
      if (_region.topLeftCoordinateXInPixel != null) _conf.col = ((_region.topLeftCoordinateXInPixel + 1) * this.scaleNum);
      if (_region.topLeftCoordinateYInPixel != null) _conf.row = ((_region.topLeftCoordinateYInPixel + 1) * this.scaleNum);
    }
    /*
      col: this._currentPosition.col,
      row: this._currentPosition.row,
      sizex: this._size.x,
      sizey: this._size.y,
      width: this._elemWidth,
      height: this._elemHeight,
      left: this._elemLeft,
      top: this._elemTop*/
    // console.log('getWidgetConfigByRegionValue() | _region > ', _region, ' | _oldconf > ', _oldconf, ' | _conf > ', _conf);
    return _conf;
  }
  processRegionForSave = (_region: Region) => {
    if (this.scaleNum > 30) return _region;  // return actual value from web-page if given accept-ratio is too small. eg. 16:9 px / 4:3 px
    // if (_region.widthInPixel != null) _region.widthInPixel = _.floor(_region.widthInPixel / this.scaleNum, 2);
    // if (_region.heightInPixel != null) _region.heightInPixel = _.floor(_region.heightInPixel / this.scaleNum, 2);
    // if (_region.topLeftCoordinateXInPixel != null) _region.topLeftCoordinateXInPixel = _.floor(_region.topLeftCoordinateXInPixel / this.scaleNum, 2);
    // if (_region.topLeftCoordinateYInPixel != null) _region.topLeftCoordinateYInPixel = _.floor(_region.topLeftCoordinateYInPixel / this.scaleNum, 2);
    return _region;
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/cms/components/template/models/template.ts